/* ==========================================================================
   SMELLERS · Constructor "Arma tu paquete"
   Elige N productos -> la promo automática de la tienda se aplica al llegar al
   mínimo (3x2 o %; se elige en el ajuste "promo_mode" de la sección).
   Aquí solo mostramos el precio en vivo y armamos el /cart/add.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-sm-builder]');
  if (!root) return;

  var MIN = parseInt(root.dataset.min, 10) || 3;
  var PCT = parseFloat(root.dataset.pct) || 30;
  var IS_3X2 = root.dataset.mode === '3x2';
  var FORMAT = root.dataset.money || '${{amount}}';

  /* ---------- formato de dinero ---------- */
  function money(cents) {
    var n = cents / 100;
    var parts = FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = parts ? parts[1] : 'amount';
    var str;

    if (kind === 'amount_no_decimals' || kind === 'amount_no_decimals_with_comma_separator') {
      str = Math.round(n).toLocaleString('es-MX');
    } else if (kind === 'amount_with_comma_separator') {
      str = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      str = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return FORMAT.replace(/\{\{\s*\w+\s*\}\}/, str);
  }

  /* ---------- estado ---------- */
  var picks = {}; // variantId -> {qty, price, title, img}

  function totalQty() {
    return Object.keys(picks).reduce(function (s, k) { return s + picks[k].qty; }, 0);
  }

  function subtotal() {
    return Object.keys(picks).reduce(function (s, k) { return s + picks[k].price * picks[k].qty; }, 0);
  }

  /* ---------- 3x2: de cada 3 articulos, el mas barato va gratis ----------
     Replica la regla del descuento automatico de Shopify ("Compra 2 y
     llevate 1 gratis", que libera las unidades mas baratas). Tiene que dar
     exactamente lo mismo que el carrito o el cliente ve un precio aqui y
     otro en el checkout. */
  function expandedPrices() {
    var out = [];
    Object.keys(picks).forEach(function (k) {
      for (var i = 0; i < picks[k].qty; i++) out.push(picks[k].price);
    });
    return out;
  }

  function total3x2() {
    var arr = expandedPrices().sort(function (a, b) { return a - b; });
    var freeCount = Math.floor(arr.length / 3);
    var total = 0;
    for (var i = 0; i < arr.length; i++) {
      if (i >= freeCount) total += arr[i];
    }
    return total;
  }

  /* ---------- refs ----------
     El dock sticky vive FUERA de [data-sm-builder], así que las consultas de
     los elementos compartidos (mensaje, precios, progreso, botón) tienen que
     ser a nivel documento. Solo las cards se buscan dentro del constructor. */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var cards = $$('[data-sm-card]', root);
  var grid = $('[data-sm-grid]');
  var dock = document.querySelector('[data-sm-dock]');
  var page = document.querySelector('[data-sm-page]');

  /* ---------- render ---------- */
  function render() {
    var qty = totalQty();
    var sub = subtotal();
    var eligible = qty >= MIN;
    var final = eligible ? (IS_3X2 ? total3x2() : Math.round(sub * (1 - PCT / 100))) : sub;
    var saved = sub - final;
    var missing = Math.max(0, MIN - qty);

    // --- slots ---
    $$('[data-sm-slots]').forEach(function (box) {
      box.innerHTML = '';
      var flat = [];
      Object.keys(picks).forEach(function (id) {
        for (var i = 0; i < picks[id].qty; i++) flat.push(picks[id]);
      });
      var shown = Math.max(MIN, flat.length);
      for (var i = 0; i < shown; i++) {
        var slot = document.createElement('div');
        slot.className = 'sm__slot';
        if (flat[i]) {
          slot.classList.add('is-filled');
          var img = document.createElement('img');
          img.src = flat[i].img;
          img.alt = flat[i].title;
          img.loading = 'lazy';
          slot.appendChild(img);
          var x = document.createElement('button');
          x.type = 'button';
          x.className = 'sm__slot-x';
          x.setAttribute('aria-label', 'Quitar ' + flat[i].title);
          x.innerHTML = '&times;';
          x.dataset.remove = flat[i].id;
          slot.appendChild(x);
        }
        box.appendChild(slot);
      }
    });

    // --- barra de progreso ---
    $$('[data-sm-progress]').forEach(function (bar) {
      bar.innerHTML = '';
      for (var i = 0; i < MIN; i++) {
        var seg = document.createElement('i');
        if (i < qty) seg.className = 'is-on';
        bar.appendChild(seg);
      }
    });

    // --- mensaje ---
    var msg;
    var DEAL = IS_3X2 ? '3x2' : PCT + '%';
    if (qty === 0) {
      msg = IS_3X2
        ? 'Elige <b>' + MIN + ' productos</b> y pagas solo 2'
        : 'Elige <b>' + MIN + ' productos</b> y el ' + PCT + '% se aplica solo';
    } else if (missing === 1) {
      msg = 'Te falta <b>1 producto</b> para tu ' + DEAL + ' + regalo';
    } else if (missing > 1) {
      msg = 'Te faltan <b>' + missing + ' productos</b> para tu ' + DEAL + ' + regalo';
    } else if (IS_3X2 && qty % MIN === MIN - 1) {
      /* con 5 piezas le falta 1 para que otra le salga gratis: se lo decimos */
      msg = 'Agrega <b>1 más</b> y te llevas <b>otro gratis</b>';
    } else {
      var freeN = Math.floor(qty / MIN);
      msg = IS_3X2
        ? '¡Listo! <b>' + (freeN > 1 ? freeN + ' te salen gratis' : '1 te sale gratis') + '</b> + regalo'
        : '¡Listo! Tienes <b>' + PCT + '% OFF + regalo</b> en tu paquete';
    }
    $$('[data-sm-msg]').forEach(function (el) { el.innerHTML = msg; });

    // --- precios ---
    $$('[data-sm-was]').forEach(function (el) {
      el.textContent = eligible && saved > 0 ? money(sub) : '';
    });
    $$('[data-sm-now]').forEach(function (el) {
      el.textContent = money(final);
    });
    $$('[data-sm-save]').forEach(function (el) {
      el.textContent = eligible && saved > 0 ? 'Ahorras ' + money(saved) : '';
    });

    // --- botón ---
    $$('[data-sm-submit]').forEach(function (btn) {
      var label = btn.querySelector('[data-sm-submit-text]') || btn;
      if (qty === 0) {
        label.textContent = 'ELEGIR MIS ' + MIN + ' PRODUCTOS';
      } else if (missing > 0) {
        if (IS_3X2) {
          label.textContent = missing === 1 ? 'AGREGA 1 MÁS Y PAGAS SOLO 2' : 'AGREGA ' + missing + ' MÁS Y PAGAS SOLO 2';
        } else {
          label.textContent = missing === 1 ? 'AGREGA 1 MÁS Y AHORRA ' + PCT + '%' : 'AGREGA ' + missing + ' MÁS Y AHORRA ' + PCT + '%';
        }
      } else {
        label.textContent = 'AGREGAR AL CARRITO · ' + money(final);
      }
      btn.dataset.state = qty === 0 ? 'empty' : missing > 0 ? 'short' : 'ready';
    });

    // --- link "comprar así" cuando faltan piezas ---
    $$('[data-sm-anyway]').forEach(function (el) {
      if (qty > 0 && missing > 0) {
        el.hidden = false;
        el.querySelector('span').textContent = 'o llévate ' + qty + ' pieza' + (qty > 1 ? 's' : '') + ' sin descuento · ' + money(sub);
      } else {
        el.hidden = true;
      }
    });

    // --- cards ---
    cards.forEach(function (card) {
      var id = card.dataset.id;
      var n = picks[id] ? picks[id].qty : 0;
      var addBtn = $('[data-sm-add]', card);
      var stepper = $('[data-sm-stepper]', card);
      var badge = $('[data-sm-cardqty]', card);
      card.classList.toggle('is-picked', n > 0);
      if (addBtn && stepper) {
        addBtn.hidden = n > 0;
        stepper.hidden = n === 0;
      }
      if (badge) {
        badge.hidden = n === 0;
        badge.textContent = n;
      }
      var val = $('[data-sm-qty]', card);
      if (val) val.textContent = n;
    });

    // --- dock mobile ---
    if (dock) {
      dock.classList.toggle('is-up', qty > 0 || dockForced);
      if (page) page.classList.toggle('sm--dock-on', qty > 0 || dockForced);
    }
  }

  /* ---------- acciones ---------- */
  function add(card) {
    var id = card.dataset.id;
    if (!picks[id]) {
      picks[id] = {
        id: id,
        qty: 0,
        price: parseInt(card.dataset.price, 10),
        title: card.dataset.title,
        img: card.dataset.img
      };
    }
    picks[id].qty += 1;
    render();
  }

  function sub1(id) {
    if (!picks[id]) return;
    picks[id].qty -= 1;
    if (picks[id].qty <= 0) delete picks[id];
    render();
  }

  root.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-sm-add]');
    if (addBtn) { add(addBtn.closest('[data-sm-card]')); return; }

    var plus = e.target.closest('[data-sm-plus]');
    if (plus) { add(plus.closest('[data-sm-card]')); return; }

    var minus = e.target.closest('[data-sm-minus]');
    if (minus) { sub1(minus.closest('[data-sm-card]').dataset.id); return; }

    /* El upsell no tiene card propia (duplicaría el variant id): dispara la
       card del grid que ya existe para ese producto. */
    var up = e.target.closest('[data-sm-upsell]');
    if (up) {
      var target = root.querySelector('[data-sm-card][data-id="' + up.dataset.smUpsell + '"]');
      if (target) {
        add(target);
        up.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
          { duration: 260, easing: 'ease-out' }
        );
      }
      return;
    }
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { sub1(rm.dataset.remove); return; }

    var f = e.target.closest('[data-sm-filter]');
    if (f) {
      $$('[data-sm-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === f)); });
      var key = f.dataset.smFilter;
      cards.forEach(function (c) {
        c.hidden = key !== 'all' && (c.dataset.family || '').indexOf(key) === -1;
      });
      return;
    }

    var submit = e.target.closest('[data-sm-submit]');
    if (submit) { onSubmit(submit); return; }

    var anyway = e.target.closest('[data-sm-anyway]');
    if (anyway) { e.preventDefault(); checkout(); return; }

    var jump = e.target.closest('[data-sm-jump]');
    if (jump) {
      e.preventDefault();
      var t = document.querySelector('[data-sm-grid]');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  function onSubmit(btn) {
    var qty = totalQty();
    if (qty < MIN) {
      // nunca se bloquea: llevamos a la clienta al grid y lo resaltamos
      if (grid) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        grid.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.012)' }, { transform: 'scale(1)' }],
          { duration: 420, easing: 'ease-out' }
        );
      }
      return;
    }
    checkout(btn);
  }

  var busy = false;
  function checkout(btn) {
    if (busy) return;
    var items = Object.keys(picks).map(function (id) {
      return { id: parseInt(id, 10), quantity: picks[id].qty };
    });
    if (!items.length) return;
    busy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) throw new Error(data.description || 'Error');
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      })
      .catch(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
        var err = $('[data-sm-error]');
        if (err) {
          err.hidden = false;
          err.textContent = 'No pudimos agregar tu paquete. Intenta de nuevo o escríbenos por WhatsApp.';
        }
      });
  }

  /* ---------- dock: aparece al llegar al constructor ---------- */
  var dockForced = false;
  if (dock && grid && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        dockForced = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
        render();
      },
      { rootMargin: '-40% 0px -20% 0px' }
    ).observe(grid);
  }

  render();
})();
